// extracted by mini-css-extract-plugin
module.exports = {"mobileView":"FootprintMovileViewColumn_mobileView__MLxzN","content":"FootprintMovileViewColumn_content__HZYDM","actions":"FootprintMovileViewColumn_actions__KKQgl"};